var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white" },
    [
      _c("FormGroup", {
        staticClass: "pl-5 py-3",
        attrs: {
          placeholder: "Search for applicant name",
          debounceTime: 500,
          type: "search",
          iconStyle: "customIcon",
          inputClass: "joblisitng_search customHeightPosting",
        },
        model: {
          value: _vm.searchText,
          callback: function ($$v) {
            _vm.searchText = $$v
          },
          expression: "searchText",
        },
      }),
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: _vm.hasNeededData,
            loading: _vm.loading,
            containerClass: "h-auto bg-white px-5",
            marginTop: "my-0",
          },
        },
        [
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "w-full flex justify-center items-center h-full",
                },
                [_c("Spinner")],
                1
              )
            : _c(
                "div",
                [
                  !_vm.loading && _vm.empty
                    ? _c("EmptyListPlaceholder", {
                        attrs: { title: _vm.emptyListPlaceholder },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "image",
                              fn: function () {
                                return [_c("EmptyListImageContractors")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          143841379
                        ),
                      })
                    : _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _vm.originalCount > 0 ? _c("div", {}) : _vm._e(),
                          _vm.isData
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex-wrap gap-4 mb-4",
                                    },
                                    _vm._l(
                                      _vm.applications,
                                      function (application) {
                                        return _c("ApplicationCard", {
                                          key: application.id,
                                          attrs: {
                                            applicationId: application.id,
                                            user: application.user,
                                            isApplicationCancelled:
                                              application.is_cancelled,
                                            status: application.status,
                                            interviewedBy:
                                              application.interviewed_by,
                                            interviewer:
                                              application.interviewer,
                                            jobTitle: _vm.jobTitle,
                                            company: _vm.company,
                                            currentUser: _vm.currentUser,
                                            note: application.note,
                                            attachedDocument:
                                              application.document,
                                            application: application,
                                            posting: application.posting,
                                          },
                                          on: {
                                            collectionChanged:
                                              _vm.refetchApplications,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _c("CardPagination", {
                                    attrs: {
                                      showmeta: false,
                                      config: _vm.paginationConfig,
                                      containerClass:
                                        "bg-transparent shadow-none border-none pb-0 pt-0 b-custom_pagination_classes",
                                    },
                                    on: {
                                      "update:config": function ($event) {
                                        _vm.paginationConfig = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c("EmptyListPlaceholder", {
                                attrs: { title: _vm.emptyListPlaceholder },
                                scopedSlots: _vm._u([
                                  {
                                    key: "image",
                                    fn: function () {
                                      return [_c("EmptyListImageContractors")]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                        ],
                        1
                      ),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }